import Cropper from 'cropperjs';
import './cropper.min.css';
import './styles.css';
import React, { useEffect, useRef, useState, forwardRef, useCallback } from 'react';

const ImageCrop = forwardRef(({ src, ...props }, ref) => {
  const imageRef = useRef();
  const [cropper, setCropper] = useState(null);

  const move = useCallback((...args) => cropper.move(...args), [cropper]);
  const zoom = useCallback((...args) => cropper.zoom(...args), [cropper]);
  const toDataURL = useCallback(() => cropper.getCroppedCanvas().toDataURL(), [cropper]);
  const toBlob = useCallback(
    () =>
      new Promise(resolve => {
        cropper.getCroppedCanvas({ fillColor: '#fff' }).toBlob(blob => resolve(blob));
      }),
    [cropper],
  );

  useEffect(() => {
    if (imageRef.current) {
      setCropper(
        new Cropper(imageRef.current, {
          aspectRatio: 1 / 1,
          background: true,
          movable: true,
          zoomable: true,
          zoomOnTouch: false,
          zoomOnWheel: false,
          toggleDragModeOnDblclick: false,
          minContainerHeight: 250,
          minContainerWidth: 250,
          minCropBoxWidth: 250,
          minCropBoxHeight: 250,
        }),
      );
    }
  }, [imageRef]);

  useEffect(() => {
    if (ref) {
      /* eslint-disable-next-line */
      ref.current = { toDataURL, toBlob, move, zoom };
    }
  }, [ref, toDataURL, toBlob, move, zoom]);

  return <div {...props}>{src && <img src={src} ref={imageRef} alt="uploaded" />}</div>;
});

export default ImageCrop;
